import { Action } from 'store/store';
import { WidgetActionPayload } from 'widgets/store/actions';
import { AnyAction } from 'redux';

export enum BlotterComponentsActionType {
    BLOTTER_COMPONENT_SET_SELECTED_ROW_IDS = 'BLOTTER_COMPONENT_SET_SELECTED_ROW_IDS',
}

export interface BlotterComponentsActionSetSelectedRowIdsPayload
    extends WidgetActionPayload {
    selectedRowIds: number[];
}

export type BlotterComponentsActionSetSelectedRowIds = Action<
    BlotterComponentsActionType.BLOTTER_COMPONENT_SET_SELECTED_ROW_IDS,
    BlotterComponentsActionSetSelectedRowIdsPayload
>;

export const blotterComponentsSetSelectedRowIdsAction = (
    widgetKey: string,
    selectedRowIds: number[]
): Action<
    BlotterComponentsActionType.BLOTTER_COMPONENT_SET_SELECTED_ROW_IDS,
    BlotterComponentsActionSetSelectedRowIdsPayload
> => ({
    type: BlotterComponentsActionType.BLOTTER_COMPONENT_SET_SELECTED_ROW_IDS,
    payload: { widgetKey, selectedRowIds },
});

export function isBlotterSetSelectedRowIdsAction(
    action: AnyAction
): action is BlotterComponentsActionSetSelectedRowIds {
    return (
        action.type ===
        BlotterComponentsActionType.BLOTTER_COMPONENT_SET_SELECTED_ROW_IDS
    );
}

export type BlotterComponentsAction = BlotterComponentsActionSetSelectedRowIds;
